export default __webpack_public_path__ + "static/media/about-img.8e7f7271.PNG";